import { useEffect } from 'react';

const SECTIONS = ['home', 'about', 'services', 'doctors', 'contact'];

export function useKeyboardNavigation() {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Only handle if Alt key is pressed
      if (!e.altKey) return;

      const currentSection = SECTIONS.find(section => 
        window.location.hash === `#${section}` || 
        document.querySelector(`#${section}`)?.getBoundingClientRect().top === 0
      );
      
      const currentIndex = currentSection ? SECTIONS.indexOf(currentSection) : -1;

      switch (e.key) {
        case 'ArrowDown':
        case 'j':
          e.preventDefault();
          if (currentIndex < SECTIONS.length - 1) {
            const nextSection = SECTIONS[currentIndex + 1];
            document.querySelector(`#${nextSection}`)?.scrollIntoView({ behavior: 'smooth' });
          }
          break;

        case 'ArrowUp':
        case 'k':
          e.preventDefault();
          if (currentIndex > 0) {
            const prevSection = SECTIONS[currentIndex - 1];
            document.querySelector(`#${prevSection}`)?.scrollIntoView({ behavior: 'smooth' });
          }
          break;

        case 'Home':
        case '1':
          e.preventDefault();
          document.querySelector('#home')?.scrollIntoView({ behavior: 'smooth' });
          break;

        case 'End':
        case '5':
          e.preventDefault();
          document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
} 